import MasterCrudPage from "../../components/MasterCrudPage";
import {
  establishmentKycApi,
  userMasterApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function EstablishmentKyc() {
  return (
    <MasterCrudPage
      title="Establishment KYC"
      description="Registration details for establishment users (Is Establishment = Yes)."
      idKey="establishment_kyc_id"
      api={establishmentKycApi}
      listLabel="establishment KYC records"
      loadExtraOptions={async () => {
        const users = await userMasterApi.list();
        return {
          establishments: (users || [])
            .filter((user) => Number(user.is_establishment) === 1)
            .map((user) => ({
              value: user.user_id,
              label: userLabel(user),
            })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User (Is Establishment = Yes)",
          type: "select",
          required: true,
          optionsKey: "establishments",
          placeholder: "Select establishment user",
        },
        {
          name: "registration_number",
          label: "Registration Number",
          type: "text",
          required: true,
          placeholder: "Registration number",
        },
        {
          name: "registration_certificate",
          label: "Registration Certificate",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
        },
        {
          name: "registration_body",
          label: "Registration Body",
          type: "text",
          placeholder: "Issuing body / authority",
        },
        {
          name: "registration_date",
          label: "Registration Date",
          type: "date",
        },
        {
          name: "expiry_date",
          label: "Expiry Date",
          type: "date",
        },
        {
          name: "kyc_verified",
          label: "KYC Verified",
          type: "checkbox",
          defaultValue: false,
          checkLabel: "Verified",
        },
        {
          name: "kyc_verification_by",
          label: "KYC Verification By",
          type: "text",
          placeholder: "Verifier name",
        },
        {
          name: "kyc_verification_date",
          label: "KYC Verification Date",
          type: "date",
        },
        {
          name: "kyc_verification_certificate",
          label: "KYC Verification Certificate",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
        },
      ]}
      columns={[
        { key: "establishment_kyc_id", label: "ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.user_id, item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        { key: "registration_number", label: "Registration Number" },
        { key: "registration_body", label: "Registration Body" },
        { key: "registration_date", label: "Registration Date" },
        { key: "expiry_date", label: "Expiry Date" },
        { key: "kyc_verified", label: "Verified", type: "status" },
        { key: "kyc_verification_by", label: "Verified By" },
        { key: "kyc_verification_date", label: "Verified Date" },
      ]}
    />
  );
}
